import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const ValOrDash = ({ val }) => {
    return (val ?? _jsx(_Fragment, { children: "\u2014" }));
};
export default ValOrDash;
